import { componentProjectsRestResource } from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { GetComponentProjectListRequest } from "./get-component-project-list/GetComponentProjectListRequest";
import { GetComponentProjectListResponse } from "./get-component-project-list/GetComponentProjectListResponse";
import { GetComponentProjectsDeployCandidateRequest } from "./get-component-projects-deploy-candidate/GetComponentProjectsDeployCandidateRequest";
import { GetComponentProjectsDeployCandidateResponse } from "./get-component-projects-deploy-candidate/GetComponentProjectsDeployCandidateResponse";
import { UpdateComponentProjectsRequest } from "./update-component-projects/UpdateComponentProjectsRequest";
import { UpdateComponentProjectsResponse } from "./update-component-projects/UpdateComponentProjectsResponse";

export const useGetComponentProjectList = () =>
  useRestResourceHook<
    GetComponentProjectListRequest,
    GetComponentProjectListResponse
  >((request) =>
    componentProjectsRestResource.getComponentProjectList(request),
  );
export const useUpdateComponentProjects = () =>
  useRestResourceHook<
    UpdateComponentProjectsRequest,
    UpdateComponentProjectsResponse
  >((request) =>
    componentProjectsRestResource.updateComponentProjects(request),
  );
export const useGetComponentProjectsDeployCandidate = () =>
  useRestResourceHook<
    GetComponentProjectsDeployCandidateRequest,
    GetComponentProjectsDeployCandidateResponse
  >((request) =>
    componentProjectsRestResource.getComponentProjectsDeployCandidate(request),
  );
